import React from 'react';
import aboutImage from '../../assets/images/about-biogas-plant.jpg';
import Reveal from '../Reveal/Reveal';
import { IconCertificate, IconShieldCheck, IconReport } from '../Icons/Icons';
import '../../assets/css/about.css';

const CAPABILITIES = [
  {
    icon: IconCertificate,
    title: 'Certification & Assurance',
    text: 'ISCC EU, ISCC PLUS and industry-specific certification readiness, GAP analyses and internal audits.',
  },
  {
    icon: IconShieldCheck,
    title: 'Regulatory Compliance',
    text: 'Mass balance systems, GHG calculations, supply chain traceability and audit preparation.',
  },
  {
    icon: IconReport,
    title: 'Sustainability Reporting',
    text: 'GGSS and RTFO reporting, PoS reviews, Nabisy and DENA compliance and supplier due diligence.',
  },
];

function About() {
  return (
    <section className="section about" id="about">
      <div className="about-backdrop" aria-hidden="true">
        <span className="about-glow about-glow-teal" />
        <span className="about-glow about-glow-green" />
      </div>

      <div className="container split-layout">
        <Reveal direction="left">
          <div className="about-image-wrap">
            <img
              src={aboutImage}
              alt="Twin anaerobic digester tanks at a biogas plant in a green field"
            />
            <div className="about-image-accent" />

            <div className="about-image-badge">
              <span className="about-image-badge-icon">
                <IconShieldCheck width={18} height={18} />
              </span>
              <span>Independent &amp; Impartial</span>
            </div>

            <div className="about-image-tag">
              <span>Certification · Compliance · Reporting</span>
            </div>
          </div>
        </Reveal>

        <Reveal direction="right">
          <div className="about-content">
            <span className="section-label">About Us</span>
            <h2 className="section-title">About Sustainability Advisory Ltd</h2>
            <p className="about-intro">
              Sustainability Advisory Ltd is a consultancy supporting organisations in the
              renewable fuels, bioenergy and low-carbon energy sectors, helping businesses
              understand and comply with sustainability requirements, certification schemes and
              regulatory obligations so products and feedstocks can be traded with confidence in
              UK and international markets. Our expertise spans biomethane, biofuels, Sustainable
              Aviation Fuel (SAF), waste-derived fuels and other renewable energy products.
            </p>

            <div className="about-capabilities">
              {CAPABILITIES.map((cap) => {
                const Icon = cap.icon;
                return (
                  <div className="about-capability" key={cap.title}>
                    <span className="about-capability-icon">
                      <Icon width={22} height={22} />
                    </span>
                    <div>
                      <h3 className="about-capability-title">{cap.title}</h3>
                      <p className="about-capability-text">{cap.text}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export default About;
